import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, List, ListItem, ListItemText, Button } from '@mui/material';

// Example static content from main sections
const sections = [
  {
    id: 'home',
    title: 'Maritime Excellence Across Borders',
    content: 'Connecting Somalia, Yemen, Oman, UAE, Pakistan, India, and Kenya through reliable and efficient maritime transport solutions.'
  },
  {
    id: 'about',
    title: 'About Us',
    content: 'Gobaad Logistics and Trading is a leading provider of maritime logistics solutions, connecting key trade routes across the region.'
  },
  {
    id: 'services',
    title: 'Our Services',
    content: 'We offer marine cargo, container shipping, bulk cargo, door-to-door delivery, and customs clearance.'
  },
  {
    id: 'routes',
    title: 'Trade Routes',
    content: 'Our trade routes cover Somalia, Yemen, Oman, UAE, Pakistan, India, and Kenya.'
  },
  {
    id: 'contact',
    title: 'Contact Us',
    content: 'Get in touch with us for your shipping needs. Email: info@gobaadlogistics.com, Phone: +202-812-2236.'
  },
];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const highlight = (text, query) => {
  if (!query) return text;
  const parts = text.split(new RegExp(`(${query})`, 'gi'));
  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? <mark key={i}>{part}</mark> : part
  );
};

const SearchResults = () => {
  const query = useQuery().get('q') || '';
  const results = sections.filter(
    section =>
      section.title.toLowerCase().includes(query.toLowerCase()) ||
      section.content.toLowerCase().includes(query.toLowerCase())
  );

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ py: 6, px: { xs: 2, sm: 6 }, minHeight: '60vh' }}>
      <Typography variant="h4" gutterBottom>
        Search Results for "{query}"
      </Typography>
      {results.length === 0 ? (
        <Typography>No results found.</Typography>
      ) : (
        <List>
          {results.map(section => (
            <ListItem key={section.id} alignItems="flex-start" sx={{ mb: 2, background: '#f7f7f7', borderRadius: 2 }}>
              <ListItemText
                primary={highlight(section.title, query)}
                secondary={highlight(section.content, query)}
              />
              <Button variant="outlined" onClick={() => handleScroll(section.id)} sx={{ ml: 2 }}>
                Go to Section
              </Button>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default SearchResults; 